import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-laborer-feed-bin",
  "use": "icon-laborer-feed-bin-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 64 64\" id=\"icon-laborer-feed-bin\"><path d=\"M23 14c-1.105 0-2.5.895-2.5 2L16 34h2l4-16a2 2 0 0 1 2-2h16a2 2 0 0 1 2 2l4 16h2l-4.5-18c0-1.105-1.395-2-2.5-2H23zM22 39h20a2 2 0 0 1-2 2H24a2 2 0 0 1-2-2zM22 34h-6v2h6v3h2v-3a2 2 0 0 0-2-2zM42 34a2 2 0 0 0-2 2v3h2v-3h6v-2h-6z\" /><path d=\"M18 36h-2v8c-.017 1.672.502 2.02 2 2h28c1.607.028 2.027-.394 2-2v-8h-2v8H18v-8z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol